import { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../core/auth/authSlice";
import { User } from "../../../../shared/models";
import Button from "../../../essentials/button/Button";
import AcedModal from "../../../essentials/modals/aced-modal/AcedModal";
import ConfirmationModal from "../../../essentials/modals/confirmation-modal/ConfirmationModal";
import UserCard from "../../../essentials/user-card/UserCard";
import "./EditModal.scss";

export interface EditModalProps {
	state: {
		isModalOpen: any;
		setModalOpen: any;
	};
	description: string;
	onEdit: any;
	title: string;
}

const EditModal: React.FC<EditModalProps> = ({
	state,
	description,
	onEdit,
	title,
}) => {
	const {
		control,
		handleSubmit,
		formState: { dirtyFields },
		reset,
		register,
	} = useForm({
		defaultValues: {
			description: typeof description === "string" ? description : "",
		},
	});

	useEffect(() => {
		// If the modal is reopened, rehydrate form with new data
		if (state.isModalOpen) {
			reset({
				description: typeof description === "string" ? description : "",
			});
		}
	}, [state.isModalOpen, description, reset]);

	// Watch the description field to enable/disable button
	const descriptionValue = useWatch({
		control,
		name: "description",
	});

	// Check if there's content in the textarea
	const hasContent = descriptionValue?.trim().length > 0;

	const [isModalOpen, setModalOpen] = useState(false);
	const user = useSelector(selectUser) as User;

	return (
		<>
			<AcedModal
				state={state}
				title={title}
				onClose={dirtyFields.description ? () => setModalOpen(true) : null}
			>
				<div className="edit-post-modal">
					<div className="edit-post-header">
						<UserCard
							userInfo={{ ...user, id: user.userId }}
							darkMode={true}
							onClick={() => {}}
						/>
					</div>

					<form
						className="edit-post"
						onSubmit={handleSubmit((data: any) => onEdit(data.description))}
					>
						<div className="edit-post-content">
							<textarea
								{...register("description")}
								placeholder="Edit your post..."
								className="edit-post-textarea"
								rows={6}
							/>
						</div>

						<div className="edit-post-toolbar">
							<div className="toolbar-icons"></div>

							<div className="publish-section">
								<Button
									className={`btn btn-primary publish-btn ${
										hasContent ? "btn-active" : "btn-inactive"
									}`}
									type="submit"
									disabled={!hasContent}
								>
									Save
								</Button>
							</div>
						</div>
					</form>
				</div>
			</AcedModal>

			{isModalOpen && (
				<ConfirmationModal
					title="You have unsaved changes. Exit?"
					state={{ isModalOpen, setModalOpen }}
					onConfirm={() => {
						state.setModalOpen(false);
						setModalOpen(false);
					}}
				/>
			)}
		</>
	);
};

export default EditModal;
